/* Copyright 2020 cpke
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by cpke <cryptio@pm.me>, December 2020
 */

import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faKey, faPlus, faCog, faTrash } from "@fortawesome/free-solid-svg-icons";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import BTable from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import "react-datetime/css/react-datetime.css";
import { useTable } from "react-table";
import "./Users.css";
import { httpClient } from "../../request";
import { statusToIcon } from "../../status";

/**
 * @todo Support pagination
 *
 * @param {*} param0
 */
function Table({ columns, data }) {
  // Use the state and functions returned from useTable to build your UI
  const { getTableProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data,
  });

  // Render the UI for your table
  return (
    <BTable striped bordered hover size="sm" {...getTableProps()}>
      <thead>
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <th {...column.getHeaderProps()}>{column.render("Header")}</th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody>
        {rows.map((row, i) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map((cell) => {
                return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
              })}
            </tr>
          );
        })}
      </tbody>
    </BTable>
  );
}

/**
 * @todo: Add ability to add/edit/delete users
 */
export default function Apps() {
  const [isLoading, setLoading] = useState(true);
  const [apps, setApps] = useState(true);
  const [result, setResult] = useState(false);
  const [settingsShow, setSettingsShow] = useState(false);
  const [settingsData, setSettingsData] = useState({});

  const [createShow, setCreateShow] = useState(false);

  const [createData, setCreateData] = useState({
    name: "",
  });

  const handleCreateChange = (e) => {
    const { id, value } = e.target;
    setCreateData((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleCreateClose = () => setCreateShow(false);
  const handleCreateShow = () => setCreateShow(true);

  const handleSettingsClose = () => setSettingsShow(false);
  const handleSettingsShow = () => setSettingsShow(true);

  const handleSettingsChange = (e) => {
    const { id, value } = e.target;
    setSettingsData((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleSettingsChangeCheckbox = (e) => {
    const { id } = e.target;
    setSettingsData((prevState) => ({
      ...prevState,
      [id]: e.target.checked,
    }));
  };

  const token = JSON.parse(localStorage.getItem("token"));

  const getApps = () => {
    httpClient
      .get("/private/apps?app=56465416-65165465", {
        headers: {
          Authorization: "Bearer " + token.token,
        },
      })
      .then((response) => {
        const responseData = response.data;

        setApps(responseData.apps ? responseData.apps : []);

        setLoading(false);
      })
      .catch((error) => {
        // Catch edge cases, usually happens with network errors
        setResult({
          status: "danger",
          message: error.message,
        });
      });
  };

  const deleteApp = (app) => {
    httpClient
      .delete(`/private/apps?app=${app}`, {
        headers: {
          Authorization: "Bearer " + token.token,
        },
      })
      .then((response) => {
        setResult({
          status: "success",
          message: "Deleted app",
        });

        getApps();
      })
      .catch((error) => {
        // The error has response, it likely has an error message from the API
        if (error.response) {
          const responseData = error.response.data;
          if ("error" in responseData) {
            /* Additionally clear the input fields if we fail to login. The form will still show the text, but the email and password state values will be
             * empty, leading to a confusing error due to the app not sending any credentials in a subsequent request
             */
            setResult({
              status: "danger",
              message: responseData.error,
            });
          }
        } else {
          // Catch edge cases, usually happens with network errors
          setResult({
            status: "danger",
            message: error.message,
          });
        }
      });
  };

  const resetKeypair = (app) => {
    httpClient
      .post(`/private/resetKeyPair?app=${app}`, null, {
        headers: {
          Authorization: "Bearer " + token.token,
        },
      })
      .then((response) => {
        const responseData = response.data;

        if (responseData.status === true) {
          setResult({
            status: "success",
            message: "Successfully reset keypair",
          });

          getApps();
        } else {
          setResult({
            status: "danger",
            message: "An unknown error has occurred",
          });
        }
      })
      .catch((error) => {
        // The error has response, it likely has an error message from the API
        if (error.response) {
          const responseData = error.response.data;
          if ("error" in responseData) {
            /* Additionally clear the input fields if we fail to login. The form will still show the text, but the email and password state values will be
             * empty, leading to a confusing error due to the app not sending any credentials in a subsequent request
             */
            setResult({
              status: "danger",
              message: responseData.error,
            });
          }
        } else {
          // Catch edge cases, usually happens with network errors
          setResult({
            status: "danger",
            message: error.message,
          });
        }
      });

      setSettingsShow(false);
  };

  const createApp = () => {
    httpClient
      .post(`/private/apps`, null, {
        headers: {
          Authorization: "Bearer " + token.token,
        },
        params: createData,
      })
      .then((response) => {
        const responseData = response.data;

        if (responseData.status === true) {
          setResult({
            status: "success",
            message: "Successfully created new app",
          });

          getApps();
        } else {
          setResult({
            status: "danger",
            message: "An unknown error has occurred",
          });
        }
      })
      .catch((error) => {
        // The error has response, it likely has an error message from the API
        if (error.response) {
          const responseData = error.response.data;
          if ("error" in responseData) {
            /* Additionally clear the input fields if we fail to login. The form will still show the text, but the email and password state values will be
             * empty, leading to a confusing error due to the app not sending any credentials in a subsequent request
             */
            setResult({
              status: "danger",
              message: responseData.error,
            });
          }
        } else {
          // Catch edge cases, usually happens with network errors
          setResult({
            status: "danger",
            message: error.message,
          });
        }
      });

    setCreateShow(false);
  };

  const updateSettings = () => {
    httpClient
      .put("/private/settings", null, {
        headers: {
          Authorization: "Bearer " + token.token,
        },
        params: settingsData,
      })
      .then((response) => {
        setResult({
          status: "success",
          message: `Successfully updated settings for app ${settingsData.app}`,
        });

        getApps(settingsData.app);
      })
      .catch((error) => {
        // The error has response, it likely has an error message from the API
        if (error.response) {
          const responseData = error.response.data;
          if ("errors" in responseData) {
            const firstError = responseData.errors[0];

            setResult({
              status: "danger",
              message: firstError.detail,
            });
          }
        } else {
          // Catch edge cases, usually happens with network errors
          setResult({
            status: "danger",
            message: error.message,
          });
        }
      });

    handleSettingsClose();
  };

  // useEffect tells the component that it must do something after it has rendered
  useEffect(() => getApps(), []);

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Reset app keypair
    </Tooltip>
  );

  const columns = React.useMemo(
    () => [
      {
        Header: "Apps",
        columns: [
          {
            Header: "Public ID",
            accessor: "PublicId",
          },
          {
            Header: "Name",
            accessor: "Name",
          },
          {
            Header: "Enabled",
            accessor: (d) => {
              return d.Settings.Enabled ? "Yes" : "No";
            },
          },
          {
            id: "settings",
            Header: "",
            accessor: (row) => {
              return row;
            },
            Cell: ({ value }) => (
              <Button
                variant="info"
                onClick={() => {
                  setSettingsData({
                    app: value.PublicId,
                    enabled: value.Settings.Enabled,
                    needsHWID: value.Settings.NeedsHWID,
                    verifyChecksum: value.Settings.VerifyChecksum,
                    forceEncryption: value.Settings.ForceEncryption,
                    checksum: value.Settings.Checksum,
                  });
                  handleSettingsShow();
                }}
              >
                <FontAwesomeIcon icon={faCog} />
              </Button>
            ),
          },
          {
            id: "del",
            Header: "",
            accessor: "PublicId",
            Cell: ({ value }) => (
              <Button
                variant="danger"
                onClick={() => {
                  if (
                    window.confirm("Are you sure you want to delete this app?")
                  )
                    deleteApp(value);
                }}
              >
                <FontAwesomeIcon icon={faTrash} />
              </Button>
            ),
          },
        ],
      },
    ],
    []
  );

  return (
    <div className="Users">
      <div className="mt-5">
        {result && (
          <Alert variant={result.status}>
            <span className="mr-1">
              <FontAwesomeIcon icon={statusToIcon[result.status]} />
            </span>
            <span>{result.message}</span>
          </Alert>
        )}

        {isLoading ? (
          <div>Loading...</div>
        ) : (
          <div>
            <Table columns={columns} data={apps} />

            {apps.length === 0 && (
              <p className="text-center">No data available</p>
            )}

            <div className="float-right">
              <Button variant="success" onClick={handleCreateShow}>
                <FontAwesomeIcon icon={faPlus} />
              </Button>
            </div>

            <Modal show={settingsShow} onHide={handleSettingsClose}>
              <Modal.Header closeButton>
                <Modal.Title>App settings</Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <Form>
                  <Form.Group controlId="enabled">
                    <Form.Check
                      type="checkbox"
                      label="Enabled"
                      defaultChecked={settingsData.enabled}
                      onChange={handleSettingsChangeCheckbox}
                    />
                  </Form.Group>

                  <Form.Group controlId="disableReason">
                    <Form.Label>Disable reason</Form.Label>
                    <Form.Control
                      type="text"
                      value={settingsData.disableReason}
                      onChange={handleSettingsChange}
                      disabled={settingsData.enabled}
                    />
                  </Form.Group>

                  <Form.Group controlId="needsHWID">
                    <Form.Check
                      type="checkbox"
                      label="Needs HWID?"
                      defaultChecked={settingsData.needsHWID}
                      onChange={handleSettingsChangeCheckbox}
                    />
                  </Form.Group>

                  <Form.Group controlId="verifyChecksum">
                    <Form.Check
                      type="checkbox"
                      label="Verify checksum"
                      defaultChecked={settingsData.verifyChecksum}
                      onChange={handleSettingsChangeCheckbox}
                    />
                  </Form.Group>

                  <Form.Group controlId="forceEncryption">
                    <Form.Check
                      type="checkbox"
                      label="Force Encryption"
                      defaultChecked={settingsData.forceEncryption}
                      onChange={handleSettingsChangeCheckbox}
                    />
                  </Form.Group>

                  <Form.Group controlId="checksum">
                    <Form.Label>Checksum</Form.Label>
                    <Form.Control
                      type="text"
                      value={settingsData.checksum}
                      onChange={handleSettingsChange}
                    />
                  </Form.Group>

                  <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip}
              >
                                  <Button
                    className="mx-1"
                    variant="info"
                    onClick={() => {
                      if (
                        window.confirm(
                          "Are you sure you want to reset this app's keypair?"
                        )
                      )
                        resetKeypair(settingsData.app);
                    }}
                  >
                    <FontAwesomeIcon icon={faKey} />
                  </Button>
                  </OverlayTrigger>
                </Form>
              </Modal.Body>

              <Modal.Footer>
                <Button variant="secondary" onClick={handleSettingsClose}>
                  Cancel
                </Button>

                <Button variant="primary" onClick={updateSettings}>
                  Save Changes
                </Button>
              </Modal.Footer>
            </Modal>

            <Modal show={createShow} onHide={handleCreateClose}>
              <Modal.Header closeButton>
                <Modal.Title>Add app</Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <Form>
                  <Form.Group controlId="name">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      value={createData.name}
                      onChange={handleCreateChange}
                    />
                  </Form.Group>
                </Form>
              </Modal.Body>

              <Modal.Footer>
                <Button variant="secondary" onClick={handleCreateClose}>
                  Cancel
                </Button>

                <Button variant="primary" onClick={createApp}>
                  Save Changes
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        )}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/dashboard/Apps.js